<!-- 短剧推广链接 下拉选择框。本地搜索，没有用到远程搜索 -->
<template>
<div>
	<a-select
		mode="multiple"
		:class="[ page_type == 'effectB'? 'page-true':'page-false', ]"
		placeholder="未选择"
		notFoundContent="请先选择渠道" 
		:filter-option="false"
		@change="handleChangeS"
		:getPopupContainer="getsPopupContainer" 
		@popupScroll="scrollHandle" 
		showSearch
		allowClear
		@search="searchHandle"
		:not-found-content="gzh_fetching ? undefined : null" 
		@blur="blurHandle"
		:value="select_value"
	  >
		<a-select-option v-if="showFilterData.length > 0" :value="'-1'">全选</a-select-option>
	  
		<a-spin v-if="gzh_fetching" slot="notFoundContent" size="small" />
		<a-select-option v-for="(item,index) in showFilterData" :key="item.id" :value="item.id" :title="item.text">
		  {{item.text}}
		</a-select-option>
		<a-select-option v-if="loading_gzh_hint" value="-0-">
			<div style="color:rgb(98, 168, 234)">加载更多中...</div>
			
		</a-select-option>
	</a-select>
</div>
</template>

<script>
import { effectReceiveChannel,} from '@/request/api'
export default {
    name: 'videLinkeSelect_',
    props: ['page_type'],
	watch: { // 父组件传过来的值不支持直接修改，所以这里用新的变量接收
	    
	},
	data(){
		return {
			showFilterData: [],
			showFilterSearch: [],
			showFilterBlur: [], // 保存一份，用于失去焦点后，回复原来的数值
			
			gzh_page: 0,
			gzh_limit: 100,
			gzh_fetching: false, // 用于控制提示
			loading_gzh_control: true, // 上拉加载更多控制
			loading_gzh_hint: false, // 上拉加载更多的提示
			// 下拉框-结束
			
			qk_url_data: [], // 选择快应用书城后获取的快应用推广链接
			select_value: [], // 选中的内容
			
			all_select_control: true, // true进行全选，false取消全选
		}
    },
	computed: {
	},
    methods: {
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			return triggerNode.parentNode || document.body;
		},
		getSelectData(data){
			let that = this
			// effectReceiveChannel({
			// 	q: 9999999,
			// 	limit: e,
			// }).then(res=>{
			// 	// console.log("获取公众号",res)
			// 	that.qk_url_data = res.data
				
			// 	that.showFilterData = res.data.slice(that.gzh_page, that.gzh_limit)
			// 	that.showFilterSearch = res.data
			// 	that.showFilterBlur = res.data
			// })
			
			that.qk_url_data = data
			
			that.showFilterData = data.slice(that.gzh_page, that.gzh_limit)
			that.showFilterSearch = data
			that.showFilterBlur = data
		},
		handleChangeS(value) {
			if(value.indexOf('-1') > -1){
				// console.log("全选");
				let i_data = []
				// console.log("this.showFilterSearch",this.showFilterSearch.length);
				
				this.showFilterSearch.forEach(res=>{
					i_data.push(res.id)
				})
				// 避免已选择的内容被替换掉，所以这里是合并
				let z_data = this.select_value.concat(i_data)
				// 数组去重
				this.select_value = Array.from(new Set(z_data))
					
				
				this.$emit('handleChangeSelect', this.select_value)
			}
			else {
				this.select_value = value
				this.$emit('handleChangeSelect', value)
			}
		},
		
		// 下拉框开始
		scrollHandle(e){ // 上拉触底加载更多
			if(e.target.scrollHeight - e.target.scrollTop < 300){ // 上拉触底加载更多
				if(this.loading_gzh_control){ // 节流，保证这期间只执行一次
					let that = this
					// console.log("上拉触底加载更多gzh_page",that.gzh_page);
					let data
					if(that.showFilterData.length < that.showFilterSearch.length){ // 还有剩余内容时，再加载剩下的内容
						// console.log("that.showFilterData",that.showFilterData.length)
						// console.log("that.showFilterSearch",that.showFilterSearch.length)
						that.loading_gzh_hint = true
						that.loading_gzh_control = false
						
						// slice(开始索引,结束索引) 不改变原数组
						that.gzh_page = that.gzh_page + that.gzh_limit
						data = that.showFilterSearch.slice(that.gzh_page, that.gzh_page + that.gzh_limit)
						that.showFilterData = that.showFilterData.concat(data)
						
						that.loading_gzh_hint = false
						that.gzh_fetching = false
						that.loading_gzh_control = true
					}
				}
			}
		},
		// 选择框搜索-选择广告账户
		searchHandle(e){
			// console.log("选择框搜索",e);
			let that = this
			that.showFilterData = []
			that.gzh_fetching = true
			that.gzh_page = 0
			let f_data = []
			if(e){ // 有搜索字段
				that.showFilterBlur.forEach(res=>{
					if(res.text.indexOf(e) > -1){
						f_data.push(res)
					}
				})
				
				that.showFilterSearch = f_data // 保存一份搜索后的数据
				if(f_data.length > that.gzh_limit){
					that.showFilterData = f_data.slice(that.gzh_page, that.gzh_limit)
				}
				else {
					that.showFilterData = f_data
				}
			}
			else { // 没有搜索字段的话，要避免全部返回
				f_data = that.showFilterBlur.slice(that.gzh_page, that.gzh_limit)
				that.showFilterData = f_data
				that.showFilterSearch = that.showFilterBlur
			}
			
			that.gzh_fetching = false
		},
		// 失去焦点
		blurHandle(e){
			let that = this
			// console.log("失去焦点",e);
			// 都恢复默认值
			that.gzh_page = 0
			that.showFilterData = that.showFilterBlur.slice(that.gzh_page, that.gzh_limit)
			that.showFilterSearch = that.showFilterBlur
		},
		// 下拉框结束

    }
}
</script>

<style scoped>
.page-true {
	width: 100%;
}
.page-false {
	min-width: 300px;
	max-width: 1300px;
}
</style>